import i18n from 'config/i18n';

export const getTranslation = (translationKey, translationParams) =>
  i18n.t(translationKey, translationParams);
